import {
  Container,
  InlineFieldContainer,
  FieldContainer,
  PhoneFieldContainer,
} from './RepForm.styles';
import {countries} from '../../../options/countries';
import CustomTextField from '../../Inputs/CustomTextField/CustomTextField';
import CustomAutocomplete from '../../Inputs/CustomAutocomplete/CustomAutocomplete';
import getSortedCountryCodes from '../../../utils/helpers/getSortedCountryCodes';
import FieldError from '../../Inputs/FieldError/FieldError';
import { repRoles } from '../../../options/userRoles';

const RepForm = ({formData, errors, onChange}) => {
  return (
    <Container>
      <InlineFieldContainer>
        <FieldContainer>
          <CustomTextField
            label={'First Name'}
            id={'firstname'}
            placeholder={'Joe'}
            required
            onChange={onChange}
            error={errors.firstname}
            type={'text'}
            value={formData.firstname}
          />
        </FieldContainer>
        <FieldContainer>
          <CustomTextField
            label={'Last Name'}
            id={'lastname'}
            placeholder={'Bloggs'}
            required
            onChange={onChange}
            error={errors.lastname}
            type={'text'}
            value={formData.lastname}
          />
        </FieldContainer>
      </InlineFieldContainer>
      <InlineFieldContainer>
        <FieldContainer>
          <CustomTextField
            label={'Contact'}
            id={'email'}
            placeholder={'email@email.com'}
            required
            onChange={onChange}
            error={errors.email}
            type={'email'}
            value={formData.email}
          />
        </FieldContainer>
        <PhoneFieldContainer>
          <FieldContainer>
            <CustomAutocomplete
              label={'Code'}
              id={'telephoneCountryCode'}
              placeholder={'44'}
              onChange={onChange}
              error={errors.telephoneCountryCode}
              value={formData.telephoneCountryCode}
              options={getSortedCountryCodes()}
              telephoneCountryCode
            />
          </FieldContainer>
          <FieldContainer>
            <CustomTextField
              label={'Phone'}
              id={'telephone'}
              placeholder={'eg. 7135684527'}
              required
              onChange={onChange}
              error={errors.telephone}
              type={'text'}
              value={formData.telephone}
            />
          </FieldContainer>
        </PhoneFieldContainer>
      </InlineFieldContainer>
      <InlineFieldContainer>
        <FieldContainer>
          <CustomAutocomplete
            label={'Location'}
            id={'location'}
            placeholder={'Select Location'}
            required
            onChange={onChange}
            error={errors.location}
            value={formData.location}
            options={countries}
          />
        </FieldContainer>
        <FieldContainer>
          <CustomAutocomplete
            label={'Role'}
            id={'role'}
            placeholder={'Select Role'}
            required
            onChange={onChange}
            error={errors.role}
            value={formData.role}
            options={repRoles}
          />
        </FieldContainer>
      </InlineFieldContainer>
      {errors.saveError && <FieldError error={errors.saveError} />}

    </Container>
  )
};

export default RepForm;
